<template>
  <v-autocomplete
    :clearable="clearable"
    v-model="innerValue"
    :items="statusItems"
    :loading="isLoading"
    :rules="rules"
    :search-input="search"
    :disabled="disabled"
    :outlined="outlined"
    :label="$t('Quality Point')"
    :dense="dense"
    :multiple="multiple"
    @input="handleInput"
  ></v-autocomplete>
</template>

<script>
import { QUALITY_POINT_ITEMS } from "@/utils/consts"

export default {
  name: "QualityPointInput",
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    itemValue: {
      type: String,
      default: "pk"
    },
    dense: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      default: null
    }
  },
  data() {
    return {
      search: "",
      isLoading: false,
      innerValue: null,
      statusItems: QUALITY_POINT_ITEMS
    }
  },
  created() {},
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.innerValue = newValue
        }
      }
    }
  },
  mounted() {
    this.innerValue = this.value
  },
  methods: {
    handleInput() {
      this.$emit("input", this.innerValue)
    }
  }
}
</script>
